<template>
  <div v-bind="$attrs"
       v-on="$listeners"
       :style="containerStyle">
    <template v-if="collapse">
      <slot name="collapse" />
    </template>
    <template v-else>
      <slot name="open"/>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'BaseCollapse',
    inheritAttrs: false,
    props: {
      collapseWidth: { type: [Number, String], required: false, default: 900 },
    },
    data: function () {
      return {
        collapse: false,
        containerStyle: {
          position: 'relative',
        },
      };
    },
    mounted: function () {
      this.updateCollapseFlag();
      if(this.windowWidth < parseInt(this.collapseWidth)) {
        this.$emit('collapse');
      } else {
        this.$emit('open');
      }
    },
    computed: {
      ...mapState({
        windowWidth: state => state.window.width,
      }),
    },
    methods: {
      updateCollapseFlag: function () {
        const newVal = this.windowWidth < parseInt(this.collapseWidth);
        if (this.collapse === !newVal) {
          this.$emit(newVal ? 'collapse' : 'open');
        }
        this.collapse = newVal;
      },
    },
    watch: {
      windowWidth: function (newVal, oldVal) {
        this.updateCollapseFlag();
      },
    },
  };
</script>
